import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BannerComponent } from '@ca/ca-ng-core';
import { ActivatedRoute } from '@angular/router';
import { CaSubscriber } from '@ca/ca-utils';
import { D4CActions, PagesState, Selectors } from '../store';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import {
  PluginsComponent,
  MetaComponent,
  BreadcrumbsComponent
} from '.';

@Component({
  selector: 'ca-cms-page',
  template: `
    @if (page$ | async; as page) {
      @if (page.meta) {
        <d4c-meta [metaTags]="page.meta"></d4c-meta>
      }
      @if (page.banner) {
        <ca-banner [data]="page.banner"></ca-banner>
      }
      <d4c-breadcrumbs />
      <d4c-plugins />
    }
  `,
  imports: [CommonModule, BannerComponent, PluginsComponent, MetaComponent, BreadcrumbsComponent],
})
export class CmsPage implements OnInit, OnDestroy {
  private store = inject(Store<{ pages: PagesState }>);
  private activatedRoute = inject(ActivatedRoute);
  private sub = new CaSubscriber();

  page$ = this.store.select(Selectors.selectActivePage);

  ngOnInit(): void {
    this.sub.subscribe(this.activatedRoute.paramMap, (params) => {
      const path = [params.get('first'), params.get('second'), params.get('third')].filter(
        (e) => e != null,
      );

      if (path.length > 0) this.store.dispatch(D4CActions.LoadPage({ path }));
      else {
        console.warn('no metaUrl for CMS page');
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.closeSubscriptions();
  }
}
